import type { ChangeEvent } from "react";

import { Icon } from "./Icon";
import "./SearchInput.css";

type Props = {
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
  size?: "sm" | "md";
  className?: string;
};

export function SearchInput({
  value,
  onChange,
  placeholder = "Buscar…",
  autoFocus,
  size = "md",
  className = "",
}: Props) {
  return (
    <div className={`ui-search ui-search-${size} ${className}`.trim()}>
      <Icon name="search" size={size === "sm" ? 13 : 15} />
      <input
        type="text"
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
      />
      {value && (
        <button type="button" className="ui-search-clear" onClick={() => onChange("")} aria-label="Limpar busca">
          <Icon name="x" size={12} />
        </button>
      )}
    </div>
  );
}
